// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__nbICA","logo__img":"logo_logo__img__Yb0Rl"};